import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import SectionGuard from 'utils/route-guard/SectionGuard';
// sample page routing
const AnalysisHub = Loadable(lazy(() => import('views/pages/AnalysisHub')));
const Home = Loadable(lazy(() => import('views/pages/home')));
const Orders = Loadable(lazy(() => import('views/pages/Orders')));
const Downloads = Loadable(lazy(() => import('views/pages/Downloads')));
const Rules = Loadable(lazy(() => import('views/pages/Rules')));
const EconomicCalendar = Loadable(lazy(() => import('views/pages/EconomiCalendar')));
const Profile = Loadable(lazy(() => import('views/pages/Profile')));
const Dashboard = Loadable(lazy(() => import('views/pages/Dashboard')));
const Leaderboard = Loadable(lazy(() => import('views/pages/Leaderboard')));
const CompetitionsList = Loadable(lazy(() => import('views/pages/Competition')));
const CompetitionView = Loadable(lazy(() => import('views/pages/Competition/CompetitionView')));
const WithdrawalsSection = Loadable(lazy(() => import('views/pages/Withdrawals')));
const WithdrawalsOverview = Loadable(lazy(() => import('views/pages/Withdrawals/Overview/index')));
const Accounts = Loadable(lazy(() => import('views/pages/Withdrawals/Funds/CryptoAndOtherAccounts')));
const AccountsForm = Loadable(lazy(() => import('views/pages/Withdrawals/Funds/CryptoAndOtherAccounts/form')));
const Challenges = Loadable(lazy(() => import('views/Challenges')));
const KYCSection = Loadable(lazy(() => import('views/pages/KYC')));
const Certificates = Loadable(lazy(() => import('views/pages/Certificates')));
let MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/Error')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <SectionGuard>
                <MainLayout />
            </SectionGuard>
        </AuthGuard>
    ),
    children: [
        // {
        //     path: '/analysis-hub',
        //     element: <AnalysisHub />
        // },
        {
            path: '/home',
            element: <Home />
        },
        {
            path: '/orders',
            element: <Orders />
        },
        {
            path: '/calendar',
            element: <EconomicCalendar />
        },
        {
            path: '/downloads',
            element: <Downloads />
        },
        // {
        //     path: '/rules',
        //     element: <Rules />
        // },
        {
            path: '/profile',
            element: <Profile />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/leaderboard',
            element: <Leaderboard />
        },
        {
            path: '/competitions',
            element: <CompetitionsList />,
            children: [
                {
                    path: ':id',
                    element: <CompetitionView />
                }
            ]
        },
        {
            path: '/withdrawals',
            element: <WithdrawalsSection />,
            children: [
                {
                    path: 'overview',
                    element: <WithdrawalsOverview />
                },
                {
                    path: 'accounts',
                    element: <Accounts />,
                    children: [
                        {
                            path: 'add',
                            element: <AccountsForm />
                        },
                        {
                            path: ':id',
                            element: <AccountsForm />
                        }
                    ]
                }
            ]
        },
        {
            path: '/kyc',
            element: <KYCSection />
        },
        {
            path: '/challenges',
            element: <Challenges />
        },
        {
            path: '/certificates',
            element: <Certificates />
        },
        {
            path: '*',
            element: <MaintenanceError />
        }
    ]
};

export default MainRoutes;
